const formatCents = (cents: number | string) => {
  const parsedGoal = typeof cents === "string" ? parseInt(cents) : cents;
  const formattedDollars = `$${(parsedGoal / 100).toLocaleString()}`;

  return formattedDollars;
};

export { formatCents };
